import {Component, CUSTOM_ELEMENTS_SCHEMA, inject, viewChild} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {
    AccountGridViewEditorComponent
} from '../components/account-grid-view-editor/account-grid-view-editor.component';
import {AppGridViewService} from '../service/app-grid-view.service';
import {NgDynamicComponentsService} from '../service/ng-dynamic-components.service';

@Component({
    standalone: true,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        FormsModule,
        AccountGridViewEditorComponent
    ],
    template: `
        <div class="fullsize-vbox" style="align-items: flex-start; gap: 10px">
            <app-account-grid-view-editor #viewEditor></app-account-grid-view-editor>

            <div class="toolbar-horizontal">
                <fluent-button (click)="loadTree()">Load</fluent-button>
                <fluent-button (click)="setFontSize(20)">Font</fluent-button>
                <fluent-button (click)="showTreeDlg()">Full Dialog</fluent-button>
                <fluent-button (click)="showTreeAddItemDlg()">Add Item Dialog</fluent-button>
            </div>
        </div>
    `,
    styles: `
    `
})
export class TestViewEditorComponent {

    private readonly editor = viewChild.required<AccountGridViewEditorComponent>('viewEditor');

    private readonly appGridViewSvc = inject(AppGridViewService);
    private readonly dynCompSvc = inject(NgDynamicComponentsService);

    constructor() {
    }

    loadTree() {
        const root = this.appGridViewSvc.loadGridLayoutTree();
        console.log(root);
    }

    setFontSize(number: number) {
    }

    async showTreeDlg() {
        await AccountGridViewEditorComponent.showDialog(this.dynCompSvc);
    }

    async showTreeAddItemDlg() {
        await AccountGridViewEditorComponent.showDialog(this.dynCompSvc, {
            input: { mode: 'edit' }
        });
    }
}
